import { SchoolDays } from '@/tools/models/school-days.model';
export class ResponseCourseTemplates {

  categories: any[];
  courseTemplateId: number;
  coverUrl: string;
  description: string;
  originalCourseId: number;
  publisher: {
    id: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
  };
  thumbnailLargeUrl: string;
  thumbnailMediumUrl: string;
  thumbnailSmallUrl: string;
  title: string;
  publicTemplate: boolean;
  published?: boolean;
  locked?: boolean;
  userType?: string;
  duration ?: number;
  schoolCalendar?: SchoolDays;
  status: 'COPYING' | 'READY' | 'ERROR';

  constructor() {}

}